import {
  ShipmentsMarker,
  LGPlusShipmentMarker,
  LGShipmentsMarker,
  APTShipmentsMarker,
  APTPlusShipmentMarker,
  TimeSensitiveShipmentsMarker,
  SGSPlusShipmentMarker,
  PupShipmentsMarker,
  RouteStopMarker,
  TimeSensitiveStopMarker,
  APTStopMarker,
  AnchorPointStopMarker,
  PupStopMarker,
  PupPlusStopMarker,
  LiftGateStopMarker,
  LGPlusStopMarker,
  // PDStopMarker,
  TrailerDropStopMarker,
  SGSPlusStopMarker,
  APTPlusStopMarker,
  SpecialInstructionMarker,
  SpecialInstructionStopMarker,
  GuaranteedMarker,
  PickupStopMarker,
  DeliveryStopMarker,
  WINGDeliveryStopMarker,
  WINGPickupStopMarker,
  APTDeliveryStopMarker,
  APTPickupStopMarker,
  APTPlusDeliveryStopMarker,
  APTPlusPickupStopMarker,
  DriverMarker,
  DriverArrivedAtStopMarker,
  DriverAtFuelingMarker,
  DriverAtLunchBreakMarker,
  ReturnToTerminalMarker,
  MarkerWithBadge,
} from "./Markers";
import "./Popups/style.scss";
import { formatDeliveryWindow, getDeliveryWindowByEarlyAndLateCTA } from '@dataGrid/gridUtilities';
import appConstants from "../../appConstants";
import Tooltip from "../common/StyledToolTip";
import { getMergedCustomerLabel } from "../common/utils";
import {
  DRIVER_EVENTS,
} from "../modules/Dispatch/RouteExecution/constants";
import {
  getPendingStopStatus,
  getPickupCountForPickupMarkerBadge,
  isDriverCurrentStopPresent,
} from "../modules/Dispatch/utils/utils";
import { isPickupStop } from "../modules/IBPlanning/Common/MergeStops/utills";
import { getCustomerName } from "../modules/IBPlanning/Common/MergeStops/utills";

import { getPickupStatusTypeIcon } from "../modules/Dispatch/RouteExecution/utils/pickupStatusTypeIcon";
import DriverAtRestMarker from "./Markers/Dispatch/DriverMarkers/DriverAtRestMarker";

const MARKER_TYPE = {
  SGS12: "SGS12",
  SGS: "SGS",
  APT: "APT",
  LG: "L",
  AP: "AP",
  PUP: "PUP",
  TD: "TD",
  PUPLG: "PUP LG",
  WING: "WING",
  PTY: "PTY",
};

const PRIORITY_LIST = [MARKER_TYPE.WING, MARKER_TYPE.PTY];
const hasPriorityShipment = (stopData) =>
  stopData?.priority?.some((value) => PRIORITY_LIST.indexOf(value) > -1);

const getDispatchRouteStopsMarker = ({
  stop,
  color,
  borderColor,
  markerTextColor,
  isSelectedStop,
  gradientPrimaryColor,
  gradientSecondaryColor
}) => {
  let params = {
    stopNo: stop.stopSequence,
    backgroundColor: isSelectedStop ? markerTextColor : color,
    borderColor: isSelectedStop ? color : borderColor,
    textColor: isSelectedStop ? color : markerTextColor,
    gradientPrimaryColor,
    gradientSecondaryColor,
    size: 22,
  };
  const marker =
    stop.stopType === appConstants.STOP_TYPE.Pickup
      ? getDispatchPickupStopMarker(stop)
      : getDispatchDeliveryStopMarker(stop);
  const badgeContent =
    stop.stopType === appConstants.STOP_TYPE.Pickup
      ? getPickupCountForPickupMarkerBadge(stop)
      : null;
  return <div>{withMarkerPros({ marker, params, badgeContent })}</div>;
};

const getDispatchDeliveryStopMarker = (stopData) => {
  const constraints = [];
  if (hasPriorityShipment(stopData)) {
    constraints.push(MARKER_TYPE.WING);
  } else if (stopData?.isApt) {
    constraints.push(MARKER_TYPE.APT);
  }
  if (constraints.length > 0) {
    return pickDeliveryStopMarker({
      markerType: constraints[0],
      hasMultipleConstraints: constraints.length > 1,
    });
  } else {
    return DeliveryStopMarker;
  }
};

const pickDeliveryStopMarker = ({ markerType, hasMultipleConstraints }) => {
  let marker = {};
  switch (markerType) {
    case MARKER_TYPE.WING:
      marker = WINGDeliveryStopMarker;
      break;
    case MARKER_TYPE.APT:
      marker = hasMultipleConstraints
        ? APTPlusDeliveryStopMarker
        : APTDeliveryStopMarker;
      break;
  }
  return marker;
};

const getDispatchPickupStopMarker = (stopData) => {
  const constraints = [];
  if (hasPriorityShipment(stopData)) {
    constraints.push(MARKER_TYPE.WING);
  } else if (stopData?.isApt) {
    constraints.push(MARKER_TYPE.APT);
  }
  if (constraints.length > 0) {
    return pickPickupStopMarker({
      markerType: constraints[0],
      hasMultipleConstraints: constraints.length > 1,
    });
  } else {
    return PickupStopMarker;
  }
};

const pickPickupStopMarker = ({ markerType, hasMultipleConstraints }) => {
  let marker = {};
  switch (markerType) {
    case MARKER_TYPE.WING:
      marker = WINGPickupStopMarker;
      break;
    case MARKER_TYPE.APT:
      marker = hasMultipleConstraints
        ? APTPlusPickupStopMarker
        : APTPickupStopMarker;
      break;
  }
  return marker;
};


export const getDispatchUnassignedPickupMarker = ({theme, isActive, pickupStatus, pickupCount}) => {
  const badgeContent = pickupCount > 1 ? pickupCount : null;
  return (
    <div>
    <div data-markername={pickupStatus}>
    {getPickupStatusTypeIcon({isActive, theme, status: pickupStatus, size:27, badgeContent})}
    </div>
  </div>
  )
}

const getDispatchAssignedPickupMarker = ({
  stopData,
  isPickupActive,
  stopSequence,
  color,
  theme,
}) => {
  const markerTextColor = theme.routeMapColorPalette.MarkerTextColor;
  let params = {
    stopNo: stopSequence,
    backgroundColor: isPickupActive ? markerTextColor : color,
    borderColor: isPickupActive ? color : theme.routeMapColorPalette.MarkerBorderColor,
    textColor: isPickupActive ? color : markerTextColor,
    size: 22,
    gradientPrimaryColor: theme.gradientPrimaryColor,
    gradientSecondaryColor: theme.gradientSecondaryColor,
  };
  const pickupsStopMarker = getDispatchPickupStopMarker(stopData);
  const badgeContent = getPickupCountForPickupMarkerBadge(stopData);
  return (
    <div>
      <div data-markername={`${color}_${stopSequence}`}>
        {withMarkerPros({marker: pickupsStopMarker, params, badgeContent})}
      </div>
    </div>
  );
};

const isDriverDelayedAtStop = (data) => {
  const arrivedStopId = data?.currentStatus?.stopId;
  const arrivedStopData = data?.stops?.find(
    (stop) => stop.stopId === arrivedStopId
  );
  return (
    getPendingStopStatus(
      arrivedStopData,
      arrivedStopData?.actualArrivalTime
    ) === appConstants.STOP_STATUS.DELAYED
  );
};

const isDriverDelayed = (currentStatus) => currentStatus?.status === DRIVER_EVENTS.DelayStart;

const hasDriverArrivedAtStop = ({ driverStatus, stops, currentStatus }) => {
  return (
    driverStatus === DRIVER_EVENTS.ArrivedAtStop &&
    isDriverCurrentStopPresent({ stops, currentStatus })
  );
};

const getMarkerBackgroundColor = (routeColor, theme) => {
  if (routeColor) return theme.driverLabelBG;
  return theme.driverStatusMarkerColor;
};

const getDispatchDriverMarker = (markerProps) => {
  const {
    data,
    theme,
    data: { stops, currentStatus, driverStatus },
    color: routeColor,
  } = markerProps;

  const commonProps = {
    ...markerProps,
    borderColor: theme.markerStokeColor,
    backgroundColor: getMarkerBackgroundColor(routeColor, theme),
  };

  // Handle delay-specific markers
  if (isDriverDelayed(currentStatus)) {
    switch (driverStatus) {
      case DRIVER_EVENTS.LunchBreak:
        return <DriverAtLunchBreakMarker {...commonProps} />;
      case DRIVER_EVENTS.FuelBreak:
        return <DriverAtFuelingMarker {...commonProps} />;
      case DRIVER_EVENTS.RestBreak:
        return <DriverAtRestMarker {...commonProps} />;
      default:
        break;
    }
  }

  // Handle other markers
  if (driverStatus === DRIVER_EVENTS.ReturnToTerminal) {
    return <ReturnToTerminalMarker {...commonProps} />;
  }

  if (hasDriverArrivedAtStop({ driverStatus, stops, currentStatus })) {
    return (
      <DriverArrivedAtStopMarker
        {...commonProps}
        color={
          isDriverDelayedAtStop(data)
            ? theme.error
            : routeColor || theme.driverLabelBG
        }
      />
    );
  }
  
  // Default marker
  return <DriverMarker {...commonProps} />;
};

const getPickupTypeShipmentMarker = ({
  isActiveShipment,
  shipmentData,
  theme,
  otherMarkerColors,
}) => {
  const params = {
    stopNo: null,
    backgroundColor: isActiveShipment
      ? theme.commonAppHeaderTabColor
      : theme.HeaderSelectedText,
    borderColor: theme.AnchorTextColor,
    ...otherMarkerColors,
    textColor: null,
    size: 22,
  };
  const markerName = "PickupShipmentsMarker";
  const deliveryWindowParams = {
    data: {
      priority: shipmentData.priority,
      apt: shipmentData.apt,
    },
    value: shipmentData.deliveryWindow,
  };
  const formattedDeliveryWindow =
    getDeliveryWindowByEarlyAndLateCTA(shipmentData) ||
    formatDeliveryWindow(deliveryWindowParams);
  const tooltip = [shipmentData.shipperName, formattedDeliveryWindow];
  return (
    <Tooltip
      title={
        <div>
          {shipmentData.shipperName}
          <br />
          {formattedDeliveryWindow}
        </div>
      }
    >
      <div
        data-markername={`${markerName}_${
          isActiveShipment ? appConstants.MARKER_TYPE.ACTIVE : appConstants.MARKER_TYPE.NON_ACTIVE
        }`}
        data-tooltip={JSON.stringify(tooltip)}
      >
        {withMarkerPros({marker: PickupStopMarker, params})}
      </div>
    </Tooltip>
  );
};

const getShipmentMarker = ({shipmentData, theme, isActiveShipment}) => {
  const otherMarkerColors = {
    gradientPrimaryColor: theme.gradientPrimaryColor,
    gradientSecondaryColor: theme.gradientSecondaryColor
  }
  if(!shipmentData.isDelivery){
    return getPickupTypeShipmentMarker({
      isActiveShipment,
      shipmentData,
      theme,
      otherMarkerColors,
    });
  }
  const color = isActiveShipment ? theme.commonAppHeaderTabColor : null;
  const constraints = [];
  if (shipmentData.priority) {
    if (appConstants.PRIORITY_SHIPMENTS_ICONS[shipmentData.priority]=== appConstants.PRIORITY_ICON.HIGH) {
      constraints.push(MARKER_TYPE.SGS12);
    } else {
      constraints.push(MARKER_TYPE.SGS);
    }
  } else if (shipmentData.apt && shipmentData.apt === MARKER_TYPE.APT) {
    constraints.push(MARKER_TYPE.APT);
  }
  if (shipmentData.liftgate === MARKER_TYPE.LG) {
    constraints.push(MARKER_TYPE.LG);
  }
  if (
    shipmentData.eqpmtPref &&
    (shipmentData.eqpmtPref.toUpperCase() === MARKER_TYPE.PUP ||
      shipmentData.eqpmtPref.toUpperCase() === MARKER_TYPE.PUPLG)
  ) {
    constraints.push(MARKER_TYPE.PUP);
  }

  const markerDimension = isActiveShipment ? "35px" : "23px";
  let markerName = "";
  if (constraints.length > 0) {
    return pickShipmentMarker({
      markerType: constraints[0],
      hasMultipleConstraints: constraints.length > 1,
      color: color,
      shipmentData,
      theme,
      dimension: markerDimension,
      isActiveShipment,
    });
  } else {
    let marker = {};
    if (shipmentData?.shipmentSpecialInstruction) {
      marker = (
        <SpecialInstructionMarker
          dimension={markerDimension}
          backgroundColor={color}
          {...otherMarkerColors}
        />
      );
      markerName = "SpecialInstructionMarker";
    } else {
      marker = (
        <ShipmentsMarker
          dimension={markerDimension}
          backgroundColor={color}
          {...otherMarkerColors}
        />
      );
      markerName = "ShipmentsMarker";
    }
    const params = {
      data: {
        priority: shipmentData.priority,
        apt: shipmentData.apt,
      },
      value: shipmentData.deliveryWindow,
    };
    const tooltip = [shipmentData.displayCustomerName, formatDeliveryWindow(params)];
    return (
      <Tooltip
        enterDelay={0}
        title={
          <div>
            {getMergedCustomerLabel(shipmentData.displayCustomerName, shipmentData.consigneeName)}
            <br />
            {getDeliveryWindowByEarlyAndLateCTA(shipmentData) || formatDeliveryWindow(params)}
          </div>
        }
      >
        <div
          data-markername={`${markerName}_${
            isActiveShipment ? appConstants.MARKER_TYPE.ACTIVE : appConstants.MARKER_TYPE.NON_ACTIVE
          }`}
          data-tooltip={JSON.stringify(tooltip)}
        >
          {marker}
        </div>
      </Tooltip>
    );
  }
};

const pickShipmentMarker = ({
  markerType,
  hasMultipleConstraints,
  color,
  shipmentData,
  theme,
  dimension,
  isActiveShipment,
}) => {
  let marker = {};
  let markerName = "";
  const otherMarkerColors = {
    gradientPrimaryColor: theme.gradientPrimaryColor,
    gradientSecondaryColor: theme.gradientSecondaryColor
  }
  switch (markerType) {
    case MARKER_TYPE.SGS:
      marker = hasMultipleConstraints ? (
        <SGSPlusShipmentMarker
          backgroundColor={color}
          dimension={dimension}
          {...otherMarkerColors}
        />
      ) : (
        <TimeSensitiveShipmentsMarker
          dimension={dimension}
          backgroundColor={color}
          {...otherMarkerColors}
        />
      );
      markerName = hasMultipleConstraints
        ? "SGSPlusShipmentMarker"
        : "TimeSensitiveShipmentsMarker";
      break;
    case MARKER_TYPE.SGS12:
      marker = (
        <GuaranteedMarker backgroundColor={color} dimension={dimension} />
      );
      markerName = "GuaranteedMarker";
      break;
    case MARKER_TYPE.APT:
      marker = hasMultipleConstraints ? (
        <APTPlusShipmentMarker
          dimension={dimension}
          backgroundColor={color}
          {...otherMarkerColors}
        />
      ) : (
        <APTShipmentsMarker dimension={dimension} backgroundColor={color} {...otherMarkerColors} />
      );
      markerName = hasMultipleConstraints
        ? "APTPlusShipmentMarker"
        : "APTShipmentsMarker";
      break;
    case MARKER_TYPE.LG:
      marker = hasMultipleConstraints ? (
        <LGPlusShipmentMarker
          dimension={dimension}
          backgroundColor={color}
          {...otherMarkerColors}
        />
      ) : (
        <LGShipmentsMarker dimension={dimension} backgroundColor={color} {...otherMarkerColors} />
      );
      markerName = hasMultipleConstraints
        ? "LGPlusShipmentMarker"
        : "LGShipmentsMarker";
      break;
    case MARKER_TYPE.PUP:
      marker = (
        <PupShipmentsMarker
          dimension={dimension}
          backgroundColor={color}
          {...otherMarkerColors}
        />
      );
      markerName = "PupShipmentsMarker";
      break;
    default:
      marker = (
        <ShipmentsMarker
          dimension={dimension}
          backgroundColor={color}
          {...otherMarkerColors}
        />
      );
      markerName = "ShipmentsMarker";
      break;
  }
  const params = {
    data: {
      priority: shipmentData.priority,
      apt: shipmentData.apt,
    },
    value: shipmentData.deliveryWindow,
  };
  const tooltip = JSON.stringify([
    shipmentData.displayCustomerName,
    formatDeliveryWindow(params),
  ]);
  return (
    <Tooltip
      title={
        <div>
          {getMergedCustomerLabel(shipmentData.displayCustomerName, shipmentData.consigneeName)}
          <br />
          {getDeliveryWindowByEarlyAndLateCTA(shipmentData) || formatDeliveryWindow(params)}
        </div>
      }
    >
      <div
        data-markername={`${markerName}_${
          isActiveShipment ? appConstants.MARKER_TYPE.ACTIVE : appConstants.MARKER_TYPE.NON_ACTIVE
        }`}
        data-tooltip={tooltip}
      >
        {marker}
      </div>
    </Tooltip>
  );
};

const getConstraints = (stopData) => {
  const constraints = [];
  const eqptType = [MARKER_TYPE.PUP, MARKER_TYPE.PUPLG];
  if (stopData.isGTDTDD || stopData.priority) {
    if (appConstants.PRIORITY_SHIPMENTS_ICONS[stopData.priority] === appConstants.PRIORITY_ICON.HIGH) {
      constraints.push(MARKER_TYPE.SGS12);
    } else {
      constraints.push(MARKER_TYPE.SGS);
    }
  } else if (stopData.apt && stopData.apt === MARKER_TYPE.APT) {
    constraints.push(MARKER_TYPE.APT);
  }
  if (stopData.liftgate === MARKER_TYPE.LG) {
    constraints.push(MARKER_TYPE.LG);
  }
  if (stopData.stopType === MARKER_TYPE.AP) {
    constraints.push(MARKER_TYPE.AP);
  }
  if (stopData.eqptPref && eqptType.includes(stopData.eqptPref)) {
    constraints.push(MARKER_TYPE.PUP);
  }
  // will be uncommented when markers become available
  // if(stopData.stopType === "P/D"){
  //   constraints.push("isPD");
  // }
  if (stopData.stopType === MARKER_TYPE.TD) {
    constraints.push(MARKER_TYPE.TD);
  }
  return constraints;
};
const getRouteStopMarkerProps = ({
  stopData,
  borderColor,
  markerTextColor,
  color,
  isSelectedStop,
  isAnchorStop,
  theme
}) => {
  const commonProps = {
    stopNo: stopData.stopSequence,
    dimension: isSelectedStop ? '40px' : '30px',
    gradientPrimaryColor: theme.gradientPrimaryColor,
    gradientSecondaryColor: theme.gradientSecondaryColor
  };
  if (isAnchorStop) {
    return {
      ...commonProps,
      backgroundColor: color,
      border: borderColor,
      textColor: markerTextColor
    };
  }
  return {
    ...commonProps,
    backgroundColor: isSelectedStop ? markerTextColor : color,
    border: isSelectedStop ? color : borderColor,
    textColor: isSelectedStop ? color : markerTextColor
  };
};
const getRouteStopMarker = ({
  stopData,
  theme,
  borderColor,
  markerTextColor,
  color,
  isSelectedStop,
  isAnchorStop,
}) => {
  if(isPickupStop(stopData.stopType)){
    let params = {
      size: 22,
      stopNo: stopData.stopSequence,
      backgroundColor: isSelectedStop ? markerTextColor : color,
      borderColor: isSelectedStop ? color : borderColor,
      textColor: isSelectedStop ? color : markerTextColor,
      gradientPrimaryColor: theme.gradientPrimaryColor,
      gradientSecondaryColor: theme.gradientSecondaryColor
    };
    return (
      <Tooltip
        title={
          <div>
            {stopData.shipperName}
            <br />
            ETA: {stopData.eta}
          </div>
        }
      >
        <div>{withMarkerPros({marker: PickupStopMarker, params})}</div>
      </Tooltip>
    );
  }
  const propArray = {
    ...getRouteStopMarkerProps({stopData, borderColor, markerTextColor, color, isSelectedStop, isAnchorStop, theme}),
  };
  const constraints = getConstraints(stopData);
  if (constraints.length > 0) {
    return pickStopMarker(
      constraints[0],
      constraints.length > 1,
      stopData,
      propArray,
      theme,
      isSelectedStop
    );
  } else {
    let marker = {};
    if (stopData.specialInstruction) {
      propArray.dimension = isSelectedStop ? "50px" : "40px";
      marker = SpecialInstructionStopMarker;
    } else {
      marker = RouteStopMarker;
    }
    return (
      <Tooltip
        title={
          <div>
            {getCustomerName(stopData)}
            <br />
            ETA: {stopData.eta}
          </div>
        }
      >
        <div>{withMarkerPros({marker, params: propArray})}</div>
      </Tooltip>
    );
  }
};

const pickStopMarker = (
  markerType,
  hasMultipleConstraints,
  stopData,
  propArray,
  theme,
  isSelectedStop
) => {
  let marker = {};
  propArray.dimension = isSelectedStop ? "50px" : "40px";
  switch (markerType) {
    case MARKER_TYPE.SGS12:
      propArray.dimension = isSelectedStop ? "40px" : "30px";
      marker = GuaranteedMarker;
      break;
    case MARKER_TYPE.SGS:
      marker = hasMultipleConstraints
        ? SGSPlusStopMarker
        : TimeSensitiveStopMarker;
      break;
    case MARKER_TYPE.APT:
      marker = hasMultipleConstraints ? APTPlusStopMarker : APTStopMarker;
      break;
    case MARKER_TYPE.LG:
      marker = hasMultipleConstraints ? LGPlusStopMarker : LiftGateStopMarker;
      break;
    case MARKER_TYPE.PUP:
      marker = hasMultipleConstraints ? PupPlusStopMarker : PupStopMarker;
      break;
    case MARKER_TYPE.TD:
      marker = TrailerDropStopMarker;
      break;
    case MARKER_TYPE.AP:
      marker = AnchorPointStopMarker;
      break;
    default:
      marker = RouteStopMarker;
      break;
  }
  return (
    <Tooltip
      title={
        <div>
          {getCustomerName(stopData)}
          <br />
          ETA: {stopData.eta}
        </div>
      }
    >
      <div>{withMarkerPros({marker, params: propArray})}</div>
    </Tooltip>
  );
};

const withMarkerPros = ({ marker: MarkerComponent, params, badgeContent = null }) => {
  if (badgeContent !== null) {
    return (
      <MarkerWithBadge MarkerComponent={MarkerComponent} {...params} badgeContent={badgeContent} />
    );
  }
  return <MarkerComponent {...params} />;
};

const getWayPoints = (routeStops) => {
  if (routeStops && routeStops.length > 0) {
    routeStops = routeStops.slice(); //mobxArray sort and reverse will not change array in place, recomended to use mobxArray.slice().sort() Ref:=> https://mobx.js.org/refguide/array.html
    return routeStops
      .sort((stop, nextStop) => stop.stopSequence - nextStop.stopSequence)
      .map((stop) => ({
        location: { lat: stop.latitude, lng: stop.longitude },
      }));
  }
  return null;
};

const getLastStop = (routeStops) => {
  if (routeStops && routeStops.length > 0) {
    routeStops = routeStops.slice(); // Need to slice an mobx observable array before applying any array functions
    const stops = routeStops.sort(
      (prevStop, currentStop) =>
        prevStop.stopSequence - currentStop.stopSequence
    );
    const lastStop = stops[stops.length - 1];
    return { lat: lastStop.latitude, lng: lastStop.longitude };
  }
  return null;
};

const getDispatchLastStop = (routeStops) => {
  if (routeStops && routeStops.length > 0) {
    routeStops = routeStops.slice(); // Need to slice an mobx observable array before applying any array functions
    const stops = routeStops.sort(
      (prevStop, currentStop) =>
        prevStop.stopSequence - currentStop.stopSequence
    );
    const lastStop = stops[stops.length - 1];
    return { lat: lastStop.latitude, lng: lastStop.longitude };
  }
  return null;
};

const getDispatchWayPoints = (routeStops) => {
  if (routeStops && routeStops.length > 0) {
    routeStops = routeStops.slice(); //mobxArray sort and reverse will not change array in place, recomended to use mobxArray.slice().sort() Ref:=> https://mobx.js.org/refguide/array.html
    return routeStops
      .sort((stop, nextStop) => stop.stopSequence - nextStop.stopSequence)
      .map((stop) => ({
        location: { lat: stop.latitude, lng: stop.longitude },
      }));
  }
  return null;
};

export {
  getDispatchAssignedPickupMarker,
  getDispatchRouteStopsMarker,
  getDispatchWayPoints,
  getShipmentMarker,
  getWayPoints,
  getLastStop,
  getRouteStopMarker,
  getDispatchLastStop,
  getDispatchDriverMarker,
  getRouteStopMarkerProps,
};
